"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const Text_1 = __importDefault(require("../../../Text"));
function TableFooter({ errorText, loading = false, styles, colSpan, pageLength = 0 }) {
    if (pageLength === 0) {
        return (react_1.default.createElement(core_1.TableFooter, null,
            react_1.default.createElement(core_1.TableRow, null,
                react_1.default.createElement(core_1.TableCell, { className: styles.footerCell, colSpan: colSpan }, !loading ? (react_1.default.createElement(react_1.default.Fragment, null, errorText ? (react_1.default.createElement(Text_1.default, { variant: "span", color: "error" }, errorText)) : (react_1.default.createElement(Text_1.default, null, "No records found")))) : (react_1.default.createElement("div", { className: styles.cellAlign },
                    react_1.default.createElement(core_1.CircularProgress, { color: "secondary", size: 16, variant: "indeterminate" }),
                    react_1.default.createElement("span", { className: styles.leftSpace }, "Loading...")))))));
    }
    return null;
}
exports.default = TableFooter;
//# sourceMappingURL=index.js.map